import React, { useEffect, useState } from "react";
import GuideSection from "../components/guide/GuideSection";
import { paymentGuide } from "../components/guide/guideContent";
import { formatPrice } from "../utils/formatPrice";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { removeFromCart } from "../redux/actions/CartActions";
import { FiEdit2, FiLock, FiPlus, FiTrash2 } from "react-icons/fi";
import "./styles/cart.css";
import { useNavigate } from "react-router-dom";
import serviceCode from "../assets/data/serviceCode.json";
import { removeFromServiceList } from "../redux/actions/ServiceListActions";
import {
  updateAdminRequest,
  updateBusinessRequest,
  updateDomiciliationRequest,
  updateJuridiqueRequest,
} from "../redux/actions/RequestActions";
import Swal from "sweetalert2";
import Loader from "../components/loader/Loader";
import {
  cardPayment,
  checkPayment,
  mobilePayment,
  setPaymentFrom,
} from "../redux/actions/PaymentActions";
import CardPaymentMethod, {
  CARD,
} from "../components/payment/CardPaymentMethod";
import useCardOffer from "../hooks/useCardOffer";
import { useFormik } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import services from "../assets/data/services.json";
import { FLOW_REQUESTS } from "../utils/serviceFlows";
import {
  PROCEDURES,
  creationDelay,
  isAssociation,
  procedureFor,
} from "../utils/creationFlow";
import { openCardCheckout } from "../utils/cardCheckout";

const CREATION_OPTION_KEYS = [
  "oapi",
  "domiciliation",
  "platformAdmin",
  "platformJuridique",
  "logo",
  "businessCards",
  "brochures",
  "companyStamp",
];

const FLOW_PAGES = {
  domiciliation: "/domiciliation",
  platformAdmin: "/platform-admin",
  platformJuridique: "/platform-juridique",
};
const servicesEditLink = {
  creation: "/business-type-2",
  businessName: "/business-name-2",
  bank: "/bank-2",
  domiciliation: "/domiciliation-2",
  platformAdmin: "/platform-admin-2",
  platformJuridique: "/platform-juridique-2",
  oapi: "/oapi-2",
};

const OHADA_COUNTRIES = [
  "BJ",
  "BF",
  "CM",
  "CF",
  "KM",
  "CG",
  "CD",
  "CI",
  "GQ",
  "GA",
  "GN",
  "GW",
  "ML",
  "NE",
  "SN",
  "TD",
  "TG",
];

function Cart() {
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const currentStep = "Paiement";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const servicesList = useSelector((state) => state.serviceList.services);
  const { user } = useSelector((state) => state.authUser);
  const dispatch = useDispatch();
  const {
    businessCreationRequest,
    domiciliationRequest,
    juridiqueRequest,
    odooRequest,
    adminRequest,
  } = useSelector((state) => state.request);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const removeItem = async (key) => {
    const code = serviceCode[key];

    if (code) {
      setSubmitting(true);

      const updatedServicesList = servicesList.filter(
        (service) => service.code !== code,
      );

      if (cart.from === "creation") {
        await dispatch(
          updateBusinessRequest(
            user.token,
            businessCreationRequest?.reference,
            {
              services: [...updatedServicesList],
            },
            (response) => handleCallback(response, key),
          ),
        );
      } else if (cart.from === "domiciliation") {
        await dispatch(
          updateDomiciliationRequest(
            user.token,
            domiciliationRequest?.reference,
            {
              services: [...updatedServicesList],
            },
            (response) => handleCallback(response, key),
          ),
        );
      } else if (cart.from === "admin") {
        await dispatch(
          updateAdminRequest(
            user.token,
            adminRequest?.reference,
            {
              services: [...updatedServicesList],
            },
            (response) => handleCallback(response, key),
          ),
        );
      } else if (cart.from === "juridique") {
        await dispatch(
          updateJuridiqueRequest(
            user.token,
            juridiqueRequest?.reference,
            {
              services: [...updatedServicesList],
            },
            (response) => handleCallback(response, key),
          ),
        );
      }
    }
  };

  const handleCallback = async ({ success, message }, key) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    const code = serviceCode[key];

    if (success) {
      await dispatch(removeFromServiceList(code));
      await dispatch(removeFromCart(key));
      Toast.fire({
        icon: "success",
        title: "succès",
        text: "Service retiré de la commande",
      });
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  const totalHT = Object.keys(cart).reduce((sum, key) => {
    const service = cart[key];
    if (service.amount) {
      if (service.periodicity === "annuel") {
        sum += service.amount * 12;
      } else {
        sum += service.amount;
      }
    }
    return sum;
  }, 0);

  const totalTTC = totalHT;

  const requestReference =
    cart.from === "creation"
      ? businessCreationRequest?.reference
      : cart.from === "domiciliation"
        ? domiciliationRequest?.reference
        : cart.from === "admin"
          ? adminRequest?.reference
          : cart.from === "management"
            ? odooRequest?.reference
            : cart.from === "juridique" && juridiqueRequest?.reference;
  const cardOffer = useCardOffer(user?.token, requestReference, totalTTC);
  const payingByCard = Boolean(cardOffer) && selectedPayment === CARD;

  const getServiceName = (key) => {
    const businessType = cart?.businessType || cart?.company?.businessType;

    switch (key) {
      case "creation":
        return isAssociation(cart?.businessType)
          ? "Création de votre association"
          : `Création de votre ${cart?.businessType}`;
      case "businessName":
        return cart.from === "creation"
          ? "Recherche du nom par Platform98"
          : `Enregistrement du nom de votre ${businessType}`;
      case "logo":
        return "Logo";
      case "businessCards":
        return "Cartes de visite";
      case "brochures":
        return "Plaquettes";
      case "companyStamp":
        return "Cachets de l'entreprise";
      case "bank":
        return `Compte bancaire entreprise${
          cart?.bank?.name ? ` ${cart.bank.name}` : ""
        }`;
      case "domiciliation":
        return cart?.company?.businessName
          ? `Domiciliation de ${cart.company.businessName}`
          : "Domiciliation chez Platform98";
      case "oapi":
        return "Protection du nom commercial (OAPI)";
      case "platformAdmin":
        return "Administration d'entreprise";
      case "platformJuridique":
        return "Suivi juridique";
      case "platformGRH":
        return "Gestion des ressources humaines";
      case "platformSale":
        return "Relation client";
      case "platformGest":
      case "management":
        return "Gestion 360° (ERP)";
      default:
        return key;
    }
  };

  // In a company creation, complementary services are edited on the options step
  const editLinkFor = (key) => {
    // Subscription flows: main service on its page, the rest on the options step
    const flowRequest = FLOW_REQUESTS[cart.from];
    if (flowRequest) {
      if (key === flowRequest.mainKey) return `${FLOW_PAGES[key]}?from=cart`;
      if (CREATION_OPTION_KEYS.includes(key)) return "/options?from=cart";
    }

    if (cart.from === "creation" && key === "domiciliation") {
      return "/company-seat?from=cart";
    }
    if (cart.from === "creation" && key === "businessName") {
      return "/business-name";
    }
    if (cart.from === "creation" && CREATION_OPTION_KEYS.includes(key)) {
      return "/options?from=cart";
    }
    return servicesEditLink[key];
  };

  // Extra line under an item: procedure of the creation or ordered quantity
  const detailFor = (key, service) => {
    if (key === "creation" && cart.from === "creation") {
      const { businessType, procedure } = cart;

      return isAssociation(businessType)
        ? `Délai : ${creationDelay(businessType)}`
        : `Procédure ${PROCEDURES[
            procedureFor(businessType, procedure)
          ].label.toLowerCase()} · ${creationDelay(businessType, procedure)}`;
    }

    if (service.quantity) {
      return `${service.quantity} unités · ${formatPrice(
        service.amount / service.quantity,
      )} l'unité`;
    }

    return null;
  };

  const handleEditClick = (key) => {
    if (editLinkFor(key)) {
      navigate(editLinkFor(key));
    }
  };

  const handleAddServiceClick = (key) => {
    if (editLinkFor(key)) {
      navigate(editLinkFor(key));
    }
  };

  const phoneSchema = Yup.object({
    phoneNumber: Yup.string().when([], {
      is: () => selectedPayment === "OM" || selectedPayment === "MOMO",
      then: (schema) => schema.required("Le numéro de téléphone est requis"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const formik = useFormik({
    initialValues: { phoneNumber: "" },
    validationSchema: phoneSchema,
    onSubmit: async (values) => {
      setSubmitting(true);
      if (selectedPayment === "OM" || selectedPayment === "MOMO") {
        await dispatch(
          mobilePayment(
            user.token,
            {
              request:
                cart.from === "creation"
                  ? businessCreationRequest?.reference
                  : cart.from === "domiciliation"
                    ? domiciliationRequest?.reference
                    : cart.from === "admin"
                      ? adminRequest?.reference
                      : cart.from === "management"
                        ? odooRequest?.reference
                        : cart.from === "juridique" &&
                          juridiqueRequest?.reference,

              phone: values.phoneNumber,
            },
            handleMobilePaymentCallback,
          ),
        );
      } else if (selectedPayment === CARD) {
        await dispatch(setPaymentFrom("cart"));
        await dispatch(
          cardPayment(
            user.token,
            {
              request:
                cart.from === "creation"
                  ? businessCreationRequest?.reference
                  : cart.from === "domiciliation"
                    ? domiciliationRequest?.reference
                    : cart.from === "admin"
                      ? adminRequest?.reference
                      : cart.from === "management"
                        ? odooRequest?.reference
                        : cart.from === "juridique" &&
                          juridiqueRequest?.reference,
            },
            handleCardPaymentCallback,
          ),
        );
      }
    },
  });

  const handleMobilePaymentCallback = async ({ success, message, data }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      await dispatch(
        checkPayment(
          user.token,
          data.reference,
          cart.from === "creation"
            ? businessCreationRequest?.reference
            : cart.from === "domiciliation"
              ? domiciliationRequest?.reference
              : cart.from === "admin"
                ? adminRequest?.reference
                : cart.from === "management"
                  ? odooRequest?.reference
                  : cart.from === "juridique" && juridiqueRequest?.reference,

          handleCheckPaymentCallback,
        ),
      );
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
      setSubmitting(false);
    }
  };

  const handleCheckPaymentCallback = ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      Toast.fire({
        icon: "success",
        title: "Succès",
        text: message,
      });
      navigate("/finalization");
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  const handleCardPaymentCallback = async ({ success, message, data }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      setSubmitting(false);
      openCardCheckout(navigate, data);
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
      setSubmitting(false);
    }
  };

  const handlePaymentSelect = (method) => {
    setSelectedPayment(method);
    formik.resetForm();
  };

  const isDisabled =
    totalTTC <= 0 ||
    !(cart?.businessType || cart?.company?.businessType) ||
    !formik.isValid ||
    !selectedPayment;

  const cartItems = Object.keys(cart).filter(
    (key) => cart[key]?.amount !== undefined,
  );

  const periodLabel = (service) =>
    !service.periodicity
      ? "Paiement unique"
      : service.periodicity === "annuel"
        ? "Abonnement annuel"
        : "Abonnement mensuel";

  const amountFor = (service) =>
    service.periodicity === "annuel" ? service.amount * 12 : service.amount;

  const canRemove = (key) =>
    !(
      (cart.from === "creation" && key === "creation") ||
      (cart.from === "domiciliation" && key === "domiciliation") ||
      (cart.from === "admin" && key === "platformAdmin") ||
      (cart.from === "sales" && key === "platformSale") ||
      (cart.from === "juridique" && key === "platformJuridique") ||
      (cart.from === "grh" && key === "platformGRH") ||
      key === "businessName"
    );

  const canEdit = (key) =>
    !(key === "creation" || key === "oapi" || key === "management") &&
    Boolean(editLinkFor(key));

  const isCameroon =
    cart?.businessCountry === "CM" || cart?.company?.country === "CM";

  const suggestions =
    (cart?.businessType || cart?.company?.businessType) &&
    cart.from !== "management"
      ? services.filter(
          (key) =>
            !cart[key] &&
            !["creation", "domiciliation", "businessName", "bank"].includes(
              key,
            ) &&
            !(cart.from !== "creation" && key === "oapi") &&
            !(!isCameroon && key === "platformAdmin"),
        )
      : [];

  const paymentMethods = [
    { id: "OM", label: "Orange Money", logo: "/images/payment/orange.png" },
    { id: "MOMO", label: "MTN Mobile Money", logo: "/images/payment/mtn.png" },
  ];

  return (
    <div className="cart-page">
      <Header />
      <Loader isLoading={submitting} />
      <ProgressBar steps={steps} currentStep={currentStep} />

      <div className="container cart-container">
        <header className="cart-header">
          <h1 className="cart-title">
            Votre <span>panier</span>
          </h1>
          <p className="cart-lead">
            Vérifiez votre commande, puis réglez en toute sécurité par Mobile
            Money{cardOffer ? " ou par carte bancaire" : ""}.
          </p>
        </header>

        <div className="cart-layout">
          <section className="cart-items" aria-label="Services commandés">
            {cartItems.map((key) => {
              const service = cart[key];

              return (
                <article key={key} className="cart-item">
                  <div className="cart-item-main">
                    <h2 className="cart-item-title">{getServiceName(key)}</h2>
                    <span className="cart-item-period">
                      {periodLabel(service)}
                    </span>
                    {service.periodicity === "annuel" && (
                      <span className="cart-item-detail">
                        {formatPrice(service.amount)} / mois × 12 mois
                      </span>
                    )}
                    {detailFor(key, service) && (
                      <span className="cart-item-detail">
                        {detailFor(key, service)}
                      </span>
                    )}
                  </div>

                  <div className="cart-item-side">
                    <strong className="cart-item-price">
                      {formatPrice(amountFor(service))}
                    </strong>
                    <div className="cart-item-actions">
                      {canEdit(key) && (
                        <button
                          type="button"
                          className="cart-link"
                          onClick={() => handleEditClick(key)}
                        >
                          <FiEdit2 aria-hidden="true" /> Modifier
                        </button>
                      )}
                      {canRemove(key) && (
                        <button
                          type="button"
                          className="cart-link is-danger"
                          onClick={() => removeItem(key)}
                        >
                          <FiTrash2 aria-hidden="true" /> Retirer
                        </button>
                      )}
                    </div>
                  </div>
                </article>
              );
            })}

            {suggestions.length > 0 && (
              <div className="cart-suggestions">
                <h2 className="cart-section-title">
                  Vous pourriez aussi avoir besoin de
                </h2>
                <div className="cart-suggestion-grid">
                  {suggestions.map((key) => (
                    <button
                      key={key}
                      type="button"
                      className="cart-suggestion"
                      onClick={() => handleAddServiceClick(key)}
                    >
                      <span>{getServiceName(key)}</span>
                      <span className="cart-suggestion-add">
                        <FiPlus aria-hidden="true" /> Ajouter
                      </span>
                    </button>
                  ))}
                </div>
              </div>
            )}
          </section>

          <aside
            className="cart-summary"
            aria-label="Récapitulatif et paiement"
          >
            <h2 className="cart-section-title">Récapitulatif</h2>

            <div className="cart-summary-lines">
              {cartItems.map((key) => (
                <div key={key} className="cart-summary-line">
                  <span>{getServiceName(key)}</span>
                  <span>{formatPrice(amountFor(cart[key]))}</span>
                </div>
              ))}
            </div>

            {payingByCard && cardOffer.fee > 0 && (
              <div className="cart-summary-lines is-fee">
                <div className="cart-summary-line">
                  <span>Frais de paiement par carte</span>
                  <span>{formatPrice(cardOffer.fee)}</span>
                </div>
              </div>
            )}

            <div className="cart-total">
              <span>Total à payer</span>
              <strong>
                {formatPrice(payingByCard ? cardOffer.total : totalTTC)}
              </strong>
            </div>

            <h3 className="cart-pay-title">Moyen de paiement</h3>
            <div
              className="cart-pay-methods"
              role="radiogroup"
              aria-label="Moyen de paiement"
            >
              {paymentMethods.map((method) => (
                <button
                  key={method.id}
                  type="button"
                  role="radio"
                  aria-checked={selectedPayment === method.id}
                  className={`cart-pay-method ${
                    selectedPayment === method.id ? "is-selected" : ""
                  }`}
                  onClick={() => handlePaymentSelect(method.id)}
                >
                  <img src={method.logo} alt="" />
                  <span>{method.label}</span>
                </button>
              ))}
              {cardOffer && (
                <CardPaymentMethod
                  selected={selectedPayment === CARD}
                  onSelect={() => handlePaymentSelect(CARD)}
                />
              )}
            </div>

            <Form onSubmit={formik.handleSubmit} className="cart-pay-form">
              {(selectedPayment === "OM" || selectedPayment === "MOMO") && (
                <Form.Group controlId="phoneNumber" className="mb-3">
                  <Form.Label className="cart-pay-label">
                    Numéro Mobile Money
                  </Form.Label>
                  <PhoneInput
                    country={user.country.toLowerCase() || "cm"}
                    value=""
                    placeholder="Numéro de téléphone"
                    onChange={(phone) => {
                      const formattedPhone = phone.startsWith("+")
                        ? phone
                        : `+${phone}`;
                      formik.setFieldValue("phoneNumber", formattedPhone);
                    }}
                    onBlur={() => formik.setFieldTouched("phoneNumber", true)}
                    inputStyle={{
                      width: "100%",
                      height: "46px",
                      fontSize: "15px",
                      borderRadius: "12px",
                    }}
                  />
                  {formik.touched.phoneNumber && formik.errors.phoneNumber && (
                    <div className="text-danger mt-1">
                      {formik.errors.phoneNumber}
                    </div>
                  )}
                </Form.Group>
              )}

              <Button
                type="submit"
                className="cart-pay-button"
                disabled={isDisabled}
              >
                <FiLock aria-hidden="true" /> Procéder au paiement
              </Button>

              <p className="cart-fee-note">
                {payingByCard
                  ? "Vous saisirez votre carte sur la page sécurisée de notre partenaire de paiement. Des frais de paiement par carte peuvent s'ajouter au montant total."
                  : "Des frais de transaction de votre opérateur Mobile Money peuvent s'ajouter au montant total du panier."}
              </p>
            </Form>
          </aside>
        </div>
      </div>

      <GuideSection {...paymentGuide} />
    </div>
  );
}

export default Cart;
